import React, { Component } from 'react';
import { HashRouter } from 'react-router-dom';
// import style from  './App.scss';
import Home from '../routes/Home';
import Mine from '../routes/Mine/route';
import WxAuth from '../components/WxAuth';
import TabsBar from '../components/tabbar';

class App extends Component {
  state = {
    meetid: '',
  };

  componentDidMount() {
    this.refreshProps();
  }

  refreshProps() {
    let hash = window.location.hash;
    let hasharray = hash.split("/");
    const meetingid = hasharray[hasharray.length - 1];
    console.log("hasharray", hasharray);
    this.setState({ meetid: meetingid });
  }

  render() {
    console.log('meetid', this.state.meetid);
    return (
      <div style={{height: '100%'}}>
        <WxAuth />
        <HashRouter>
          <div style={{ width: '100%', height: '100%' }}>
            <TabsBar
              meetid={this.state.meetid}
              refreshProps={this.refreshProps.bind(this)}
              tabs={[
                {
                  title: '会议',
                  tab: 'home',
                  route: 'home/index',
                  Component: Home,
                },
                {
                  title: '我的',
                  tab: 'mine',
                  route: 'mine/index',
                  Component: Mine,
                },
              ]}
            />
          </div>
        </HashRouter>
      </div>
    );
  }
}

export default App;
